import { Routes } from "@angular/router";
import { LoginComponent } from "./pages/login/login.component";
import { AuthGuard } from "./guards/auth.guard";
import { NoAuthGuard } from "./guards/no-auth.guard";
import { LibroComponent } from "./pages/libro/libro.component";
import { TramiteComponent } from "./pages/tramite/tramite.component";
import { SsoLoginComponent } from "./pages/sso-login/sso-login.component";
import { SalonComponent } from "./pages/salon/salon.component";

export const ROUTES: Routes = [
  //TOKEN PRODUCCIÓN
  { path: "sso-login", component: SsoLoginComponent },
  //TOEKN DESARROLLO
  { path: "seguridad/sso-login", component: SsoLoginComponent },

  { path: "libro", component: LibroComponent, canActivate: [AuthGuard] },
  { path: "tramite/:id", component: TramiteComponent, canActivate: [AuthGuard] },
  { path: "salon", component: SalonComponent, canActivate: [AuthGuard] },
  { path: "login", component: LoginComponent, canActivate: [NoAuthGuard] },
  { path: "", pathMatch: "full", redirectTo: "salon" },
  { path: "**", pathMatch: "full", redirectTo: "salon" }
];
